import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {CommonService} from "../services/common.service";
import {profile} from "../core/shared.selectors";
import {roleUrlMap} from "../constants/common.constants";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../state/app.state";
import {FetchProfileRequest} from "../core/shared.actions";

@Injectable({
  providedIn: 'root'
})
export class UnauthenticatedGuard  {
  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isLoggedIn = this.commonService.isAuthenticated(); // ... your authentication logic here

    if(state.url.includes('/register/step-1') && !!route.queryParams['token']) {
      this.commonService.clearAppState();
      return true;
    }

    if (!isLoggedIn) {
      return true;
    } else {
      let isAllowed = false;
      let role;

      this.store.select(profile).subscribe((profile) => {
        if (profile?.id) {
          role = profile.role;
          if (role && typeof role === 'object') {
            role = role.key;
          }
          if (typeof role !== 'number') {
            this.commonService.logout();
            return;
          }

          if (roleUrlMap[role] === route.routeConfig.path) {
            isAllowed = true;
          }
        } else if(state.url.includes('/register/step-5')) {
          isAllowed = true;
        } else {
          this.store.dispatch(FetchProfileRequest());
        }
      }).unsubscribe();

      if (isAllowed) {
        return true;
      }

      if (role) {
        this.router.navigate([roleUrlMap[role]]);
      }
    }

    return false;
  }

}
